function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAssets = function SvgAssets(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.324 16.836 L 11.974 20.662 L 19.623 16.836 L 19.623 7.274 L 11.974 3.449 L 4.324 7.274 L 4.324 16.836 Z",
    stroke: "#ffffff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.896 11.321 L 11.458 10.753 C 11.733 10.848 12.056 10.848 12.331 10.753 L 11.896 11.321 Z M 3.693 8.135 L 11.423 11.623 L 12.277 10.852 L 4.515 7.557 L 3.693 8.135 Z M 12.353 11.66 L 20.145 8.328 L 19.271 7.491 L 11.536 10.801 L 12.353 11.66 Z",
    fill: "#ffffff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.87 15.121 L 11.87 11.49",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    style: {}
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAssets, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/assets.9b15fef8.svg";
export { ForwardRef as ReactComponent };